// DEFAULT STATE
export const initParams = {
  apiUrl: '',
  clientEmail: '',
  token: '',
};

// WRITES
const params = (state = {}, action) => {
  return state;
};

// READS
export const getApiUrl = (state) => state.params.apiUrl;
export const getClientEmail = (state) => state.params.clientEmail;
export const getToken = (state) => state.params.token;

export default params;
